/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechStorageUsbIcon24Solid = forwardRef('TechStorageUsbIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.629 11.47c.732.732.732 1.92 0 2.651l-5.966 5.966a6.187 6.187 0 1 1-8.75-8.75l5.966-5.966a1.875 1.875 0 0 1 2.651 0l3.182-3.182a1.875 1.875 0 0 1 2.652 0l3.447 3.447c.732.732.732 1.92 0 2.652L18.63 11.47Zm-5.038-5.038 3.977 3.977 3.182-3.182a.375.375 0 0 0 0-.53l-3.447-3.448a.375.375 0 0 0-.53 0L13.59 6.432Z" })));
});
